/**
 * 模組頁面代碼 : 1320-UI-02
 * 頁面說明 : 角色權限新增修改視窗
 * @module web/modules/role-permission/components/RolePermissionModal
 */

// ----- import from npm modules -----
import React, {useState, useEffect} from 'react';
import enumList from 'web/utils/enumList';

// ----- constants -----
const ROLE_PERMISSION_NEW = 'new';
const ROLE_PERMISSION_EDIT = 'edit';

const RESPONSE_OK = 200;
const TITLE_ROLE_PERMISSION_NEW = '新增角色權限';
const TITLE_ROLE_PERMISSION_EDIT = '修改角色權限';

const RolePermissionModal = React.forwardRef((props, ref) => {
  const {
    mode,
    roleList: roleSelection,
    moduleSelection,
    rolePermission,
    searchRolePermission,
  } = props;

  const modalIcon = mode === ROLE_PERMISSION_NEW ? '#ico-plus' : '#ico-edit';
  const modalTitleText =
    mode === ROLE_PERMISSION_NEW
      ? TITLE_ROLE_PERMISSION_NEW
      : TITLE_ROLE_PERMISSION_EDIT;

  // 初始化state
  const [formValues, setFormValues] = useState({
    modalRoleId: '',
    modalModuleId: '',
    modalRolePermSetRead: false,
    modalRolePermSetWrite: false,
    modalRolePermSetEdit: false,
    modalRolePermSetDisable: false,
  });

  const [invalidShow, setInvalidShow] = useState('none');

  // Handle change event
  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]:
        event.target.type === 'checkbox'
          ? event.target.checked
          : event.target.value,
    });
  };

  // 使用useEffect在rolePermission改變才更新formValues
  useEffect(() => {
    setFormValues({
      modalRoleId: rolePermission ? rolePermission.roleId : '',
      modalModuleId: rolePermission ? rolePermission.moduleId : '',
      modalRolePermSetRead: rolePermission
        ? rolePermission.flgRead === 1
        : false,
      modalRolePermSetWrite: rolePermission
        ? rolePermission.flgCreate === 1
        : false,
      modalRolePermSetEdit: rolePermission
        ? rolePermission.flgUpdate === 1
        : false,
      modalRolePermSetDisable: rolePermission
        ? rolePermission.flgDelete === 1
        : false,
    });
    setInvalidShow('none');
  }, [rolePermission]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    // 檢查表单是否验证通过
    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    // 建立 FormData 讀取表单的值
    const formData = new FormData(form);

    // 建立 rolePermission 物件
    const saveRolePermission = {
      permissionId:
        mode === ROLE_PERMISSION_NEW ? null : rolePermission.permissionId,
      roleId: parseInt(formData.get('modalRoleId')),
      moduleId: parseInt(formData.get('modalModuleId')),
      flgRead: 1,
      flgCreate: 1,
      flgUpdate: 1,
      flgDelete: 1,
      // flgRead: formData.get('modalRolePermSetRead') === 'on' ? 1 : 0,
      // flgCreate: formData.get('modalRolePermSetWrite') === 'on' ? 1 : 0,
      // flgUpdate: formData.get('modalRolePermSetEdit') === 'on' ? 1 : 0,
      // flgDelete: formData.get('modalRolePermSetDisable') === 'on' ? 1 : 0,
    };

    // 呼叫父層元件的新增或修改角色函式
    if (mode === ROLE_PERMISSION_NEW) {
      // 调用 props.addRolePermission 方法
      props.addRolePermission(saveRolePermission).then((response) => {
        const statusCode = response.payload.code;
        if (statusCode !== RESPONSE_OK) {
          $(ref.current).modal('hide');
          props.onErrorHandle(TITLE_ROLE_PERMISSION_NEW, response.payload);
        } else {
          // 调用 fetchRolePermissionList and Hide the modal
          const {roleId, moduleId} = searchRolePermission;
          props.fetchRolePermissionList(roleId, moduleId).then(() => {
            props.setNeedRolePermissionLoad(true);
            $(ref.current).modal('hide');
          });
        }
      });
    } else if (mode === ROLE_PERMISSION_EDIT) {
      // 调用 props.editRolePermission 方法
      props.editRolePermission(saveRolePermission).then((response) => {
        const statusCode = response.payload.code;
        if (statusCode !== RESPONSE_OK) {
          $(ref.current).modal('hide');
          props.onErrorHandle(TITLE_ROLE_PERMISSION_EDIT, response.payload);
        } else {
          // 调用 fetchRolePermissionList and Hide the modal
          const {roleId, moduleId} = searchRolePermission;
          props.fetchRolePermissionList(roleId, moduleId).then(() => {
            props.setNeedRolePermissionLoad(true);
            $(ref.current).modal('hide');
          });
        }
      });
    }
  };

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalRolePerm"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalRolePermLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalRolePermForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalRolePermLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-3">
                  <div className="modal__form__catagory__lable">角色資訊</div>
                </div>
                <div className="col-9">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="modalRoleId" className="form-label">
                        角色類別*
                      </label>
                      {mode === ROLE_PERMISSION_EDIT ? (
                        <>
                          <select
                            className="form-select form-select-sm"
                            id="modalRoleId"
                            name="modalRoleId"
                            value={formValues.modalRoleId}
                            onChange={handleChange}
                            disabled
                            required
                          >
                            <option disabled value="">
                              請選擇
                            </option>
                            {roleSelection
                              .filter(
                                ({flgStatus}) =>
                                  flgStatus !== enumList.flgStatus.inactive,
                              )
                              .map((role, index) => (
                                <option key={index} value={role.roleId}>
                                  {role.roleName}
                                </option>
                              ))}
                          </select>
                          {/* Hidden input to ensure value is submitted */}
                          <input
                            type="hidden"
                            name="modalRoleId"
                            value={formValues.modalRoleId}
                          />
                        </>
                      ) : (
                        <select
                          className="form-select form-select-sm"
                          id="modalRoleId"
                          name="modalRoleId"
                          value={formValues.modalRoleId}
                          onChange={handleChange}
                          required
                        >
                          <option disabled value="">
                            請選擇
                          </option>
                          {roleSelection
                            .filter(
                              ({flgStatus}) =>
                                flgStatus !== enumList.flgStatus.inactive,
                            )
                            .map((role, index) => (
                              <option key={index} value={role.roleId}>
                                {role.roleName}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalModuleId" className="form-label">
                        功能模組*
                      </label>
                      {mode === ROLE_PERMISSION_EDIT ? (
                        <>
                          <select
                            className="form-select form-select-sm"
                            id="modalModuleId"
                            name="modalModuleId"
                            value={formValues.modalModuleId}
                            onChange={handleChange}
                            disabled
                            required
                          >
                            <option disabled value="">
                              請選擇
                            </option>
                            {moduleSelection.map((module, index) => (
                              <option key={index} value={module.moduleId}>
                                {module.moduleName}
                              </option>
                            ))}
                          </select>
                          {/* Hidden input to ensure value is submitted */}
                          <input
                            type="hidden"
                            name="modalModuleId"
                            value={formValues.modalModuleId}
                          />
                        </>
                      ) : (
                        <select
                          className="form-select form-select-sm"
                          id="modalModuleId"
                          name="modalModuleId"
                          value={formValues.modalModuleId}
                          onChange={handleChange}
                          required
                        >
                          <option disabled value="">
                            請選擇
                          </option>
                          {moduleSelection.map((module, index) => (
                            <option key={index} value={module.moduleId}>
                              {module.moduleName}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="modal__form__catagory row">
                <div className="col-3">
                  <div className="modal__form__catagory__lable">權限設定</div>
                </div>
                <div className="col-9">
                  <div className="row mt-2">
                    <div className="col-12">
                      <div className="btn-group btn-group-sm" role="group" aria-label="checkbox toggle button group">
                        <input
                          type="checkbox"
                          className="btn-check"
                          name="modalRolePermSetRead"
                          id="modalRolePermSetRead"
                          checked={formValues.modalRolePermSetRead}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        <label className="btn btn-outline-secondary" htmlFor="modalRolePermSetRead">
                          讀取
                        </label>
                        <input
                          type="checkbox"
                          className="btn-check"
                          name="modalRolePermSetWrite"
                          id="modalRolePermSetWrite"
                          checked={formValues.modalRolePermSetWrite}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        <label className="btn btn-outline-secondary" htmlFor="modalRolePermSetWrite">
                          寫入
                        </label>
                        <input
                          type="checkbox"
                          className="btn-check"
                          name="modalRolePermSetEdit"
                          id="modalRolePermSetEdit"
                          checked={formValues.modalRolePermSetEdit}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        <label className="btn btn-outline-secondary" htmlFor="modalRolePermSetEdit">
                          修改
                        </label>
                        <input
                          type="checkbox"
                          className="btn-check"
                          name="modalRolePermSetDisable"
                          id="modalRolePermSetDisable"
                          checked={formValues.modalRolePermSetDisable}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                        <label className="btn btn-outline-secondary" htmlFor="modalRolePermSetDisable">
                          停用
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default RolePermissionModal;
